import { render, staticRenderFns } from "./InspectOrder.vue?vue&type=template&id=3c7c5f84&scoped=true"
import script from "./InspectOrder.vue?vue&type=script&lang=js"
export * from "./InspectOrder.vue?vue&type=script&lang=js"
import style0 from "./InspectOrder.vue?vue&type=style&index=0&id=3c7c5f84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c7c5f84",
  null
  
)

export default component.exports